"use client";

import Link from "next/link";
import { Button, Text, TbArrowLeft, TbSearch } from "@forestsync/ui";

interface NotFoundClientProps {
  title: string;
  description: string;
  backToGlassroomText: string;
  exploreMapText: string;
  contactSupportText: string;
}

export default function NotFoundClient({
  title,
  description,
  backToGlassroomText,
  exploreMapText,
  contactSupportText,
}: NotFoundClientProps) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center space-y-6 max-w-md mx-auto px-4">
        <div className="space-y-2">
          <Text size="xl" fw={700} className="text-gray-900 dark:text-white">
            {title}
          </Text>
          <Text className="text-gray-600 dark:text-gray-400">
            {description}
          </Text>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link href="/glassroom">
            <Button
              variant="light"
              leftSection={<TbArrowLeft size={16} />}
              className="w-full sm:w-auto"
            >
              {backToGlassroomText}
            </Button>
          </Link>
          <Link href="/fsmap">
            <Button
              leftSection={<TbSearch size={16} />}
              className="w-full sm:w-auto"
            >
              {exploreMapText}
            </Button>
          </Link>
        </div>
        <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
          <Text size="sm" className="text-gray-500 dark:text-gray-400">
            {contactSupportText}
          </Text>
        </div>
      </div>
    </div>
  );
}
